<template>
  <div class="main-chapter1">
    <div class="chapter-title">
      Замечания лиц, контролирующих производство строительно-монтажных работ и их безопасность
    </div>
    <div style="margin: 10px 0;-align: right">
      <n-link :to="{name:'journals.index', params:{ journal: 'author', projectId: project.id, }}"><n-button>Журнал авторского надзора</n-button></n-link>
      <n-link :to="{name:'journals.index', params:{ journal: 'tech', projectId: project.id, }}"><n-button>Журнал технического надзора</n-button></n-link>
    </div>
    <n-table :columns="columns" :data="data">
      <template #publishedAt="{item}">
        {{ $app.date.format(item.publishedAt) }}
      </template>
      <template #author="{item}">
        {{ item.author.fullName }}, {{ item.author.participation.position }}
      </template>
    </n-table>
  </div>
</template>

<script>
export default {
  name: 'MainChapter6',
  props: [ 'project', ],
  data: () => ({
    columns: [
      { name: 'publishedAt', title: 'Дата', },
      { name: 'author', title: 'Должность, фамилия, инициалы лица, контролирующего производство и безопасность работ', },
      { name: 'problem', title: 'Замечание лица, контролирующего производство и безопасность работ, либо ссылка на предписание об устранении замечаний', },
      { name: 'one3', title: 'Отметка о принятии замечаний к исполнению и об их устранении', },
    ],
    data: [
      // { createdAt: '10.01.2020', author: 'ТОО "Комапния Тех. Надзор", Иванов Н.Н.', record: 'Неправильно сделано', },
    ],
  }),
  created() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.main.six.get(this.project.id).query({
        'with[author][with][participation]': null,
        projectId: this.project.id,
      }).then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
